<div
  class="processing-overlay__backdrop"
  [class.processing-overlay__backdrop--visible]="visible()"
  aria-hidden="true"
></div>

@if (visible()) {
  <section
    #dialog
    class="processing-overlay"
    role="alertdialog"
    aria-modal="true"
    aria-busy="true"
    aria-labelledby="processing-overlay-title"
    aria-describedby="processing-overlay-body"
    tabindex="-1"
  >
    <img
      class="processing-overlay__mascot"
      src="/images/logo/checking_payment.png"
      alt=""
      width="640"
      height="573"
    />

    <div class="processing-overlay__dots" aria-hidden="true">
      <span></span><span></span><span></span>
    </div>

    <h2 id="processing-overlay-title" class="processing-overlay__title">
      Estamos procesando tu pago
    </h2>
    <p
      id="processing-overlay-body"
      class="processing-overlay__body"
      role="status"
      aria-live="assertive"
    >
      {{ message() ?? 'Esto puede tardar unos segundos. No cierres ni recargues esta página.' }}
    </p>
  </section>
}
